import { gql } from '@apollo/client';

export const IMPORT_UPLOAD = gql`
    mutation importUpload($file: Upload!) {
        importUpload(file: $file) {
            job {
                id
                status
                originalFilename
                fileType
                totalRows
                detectedColumns
                columnMapping
                mappableFields
                createdAt
            }
            suggestedMapping
        }
    }
`;

export const IMPORT_CONFIGURE = gql`
    mutation importConfigure(
        $jobId: ID!
        $columnMapping: JSONString!
        $duplicateStrategy: String
        $duplicateCheckField: String
    ) {
        importConfigure(
            jobId: $jobId
            columnMapping: $columnMapping
            duplicateStrategy: $duplicateStrategy
            duplicateCheckField: $duplicateCheckField
        ) {
            job {
                id
                status
                totalRows
                columnMapping
            }
            validCount
            invalidCount
        }
    }
`;

export const IMPORT_PREVIEW = gql`
    mutation importPreview($jobId: ID!, $limit: Int) {
        importPreview(jobId: $jobId, limit: $limit) {
            rows {
                id
                rowNumber
                rawData
                mappedData
                status
                errors
            }
            validCount
            invalidCount
        }
    }
`;

export const IMPORT_START = gql`
    mutation importStart($jobId: ID!) {
        importStart(jobId: $jobId) {
            job {
                id
                status
                totalRows
                processedRows
                successCount
                errorCount
                skipCount
                progressPercent
                errorSummary
            }
        }
    }
`;

export const IMPORT_JOB_STATUS = gql`
    mutation importJobStatus($jobId: ID!) {
        importJobStatus(jobId: $jobId) {
            job {
                id
                status
                originalFilename
                totalRows
                processedRows
                successCount
                errorCount
                skipCount
                progressPercent
                errorSummary
                createdAt
            }
        }
    }
`;
